import React, { useContext } from "react"
import Icon from "@kit/design/icon"
import { Drawer } from "@kit/design/drawer"
import { OldButton } from "@kit/design/old-button"
import { VisuallyHidden } from "@kit/design/visually-hidden"
import { DiscoveryHubContext } from "./discovery-hub-context"
import Badge from "@kit/design/badge"
import { useFetch } from "hooks/use-new-fetch"
import pluralize from "pluralize"

export function DrawerHeading() {
  const [request] = useFetch("/onboarding/changelog_items/mark_all_as_read")
  const context = useContext(DiscoveryHubContext)
  const handleClick = async () => {
    await request.post({ path: "/" })
    context.setNotificationCounterToZero()
  }

  return (
    <div className="flex min-w-0 items-center gap-3">
      <Icon name="alarm" />

      <Drawer.Title>What’s New</Drawer.Title>

      {context.notificationCounter > 0 && (
        <Badge variant="light">
          {context.notificationCounter}
          <VisuallyHidden>
            {" "}
            unread app {pluralize("notification", context.notificationCounter)}
          </VisuallyHidden>
        </Badge>
      )}

      {context.notificationCounter > 0 && (
        <div className="ml-5">
          <OldButton
            is="tertiary"
            size="lg"
            disabled={context.notificationCounter < 1}
            onClick={handleClick}
          >
            Mark all as read
          </OldButton>
        </div>
      )}
    </div>
  )
}
